import React from "react"
import Image from "next/image"

const TextInfoView: React.FunctionComponent<{
    className?: string,
    title?: string,
    value?: string,
    iconSrc?: string
}> = ({ className, title, value, iconSrc }) => {
    return (
        <div className={["flex items-center gap-x-[8px]", className].join(" ")}>
            {iconSrc &&
                <div className="relative w-[32px] h-[32px] overflow-hidden">
                    <Image layout="fill" objectFit="cover"
                        src={iconSrc}
                        alt={title ? `${title} Icon` : "Icon"} />
                </div>
            }

            <div>
                <div className="text-caption1 text-black-500 uppercase">{title || "-"}</div>
                <div className="text-body text-black-900">{value || "-"}</div>
            </div>
        </div>
    )
}

export default TextInfoView
